export default function gotoPDF(text) {
  if (text) {
    let result = text.slice(0, 6);
    if (result === 'Safety') {
      return ('docsafety/')
    } else {
      return ('DocLong/')
    }
  }

}

export function gotoMakePDF(text) {
  if (text) {
    let result = text.slice(0, 6);
    if (result === 'Safety') {
      return ('S')
    } else {
      return ('L')
    }
  }



  // if (text) {
  //   let result = text.slice(0, 9);
  //   if (result === 'SafetyCar') {
  //     return ('S')
  //   } else {
  //     let result = text.slice(0, 6);
  //     if (result === ' Safety') {
  //       //ເພັກແກັດໃໝ່
  //       return ('NS')
  //     }
  //     return ('L')
  //   }
  // }

}